export default __webpack_public_path__ + "static/media/fundo1.77315f5e.jpg";